import PageHeader from "@/components/PageHeader";
import FeaturesSection from "@/components/enterprise/FeaturesSection";
import ProcessSection from "@/components/enterprise/ProcessSection";
import CallToAction from "@/components/enterprise/CallToAction";
import RequestDemoButton from "@/components/demo/RequestDemoButton";

const Enterprise = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageHeader 
        title="Transform Your Immigration Practice"
        subtitle="Streamline operations, enhance client experience, and scale your business with NAVISA's enterprise solutions"
        showCta={true}
        ctaText="Request Demo"
        ctaLink="#"
        ctaComponent={
          <RequestDemoButton 
            className="bg-white hover:bg-white/90 text-black px-8 py-6 text-lg"
            tracking={{ source: 'enterprise_header' }}
          >
            Request Demo
          </RequestDemoButton>
        }
      />
      <FeaturesSection />
      <ProcessSection />
      <CallToAction />
    </div>
  );
};

export default Enterprise;